import useEventListenerOutside from "./useEventListenerOutside.es.js";
const useOnClickOutside = (handler, refs) => {
  useEventListenerOutside(handler, "mousedown", refs);
  useEventListenerOutside(handler, "touchstart", refs);
};
export {
  useOnClickOutside as default
};
//# sourceMappingURL=useOnClickOutside.es.js.map
